module.exports = __webpack_public_path__ + "static/4-4bfb7351704e480419cfa99e01b6afa5.png";